import React from "react"
import { Button, Form, Row } from "react-bootstrap"
import Modal from "../../../../../_components/Modal"
import styled from "styled-components"
import { SelectICMS } from '@taxes'
import { bindActionCreators } from 'redux';
import { connect } from "react-redux";
import { saveProduct } from "../../../../../components/pages/products/utils"
import {
    setBaseProductName,
    setBaseProductBarcode,
    setBaseProductPrice,
    // setBaseProductInternalCode,
    setMaskPrice
} from '../../../../../components/pages/products/base/actions'
import { setNcm, setCfop } from '@taxes/actions'
import { showSnackBar } from "../../../../../utils"

const ContainerDragAndDrop = styled.div`
    display: flex
    justify-content: center
    align-self: center
    max-width: 300px
    paddingTop: 30px
    cursor: pointer
    border: 3px dotted #ebebeb

    i {
        font-size: 4em
        font-weight: bold
    } 

`
import { importNFEData } from "../../../../../api/products"


function ImportCSV(props) {

    const [selectedCSV, setSelectedCSV] = React.useState({})
    const [showModal, setShowModal] = React.useState(false)
    const [copiedCheck, setCopiedCheck] = React.useState(false)

    const [allowedImport, setAllowedImport] = React.useState(false)
    const [error, setError] = React.useState('')

    const [importedProducts, setImportedProducts] = React.useState([])
    const [modalProducts, setModalProducts] = React.useState(false)
    const [disabled, setDisabled] = React.useState(false)

    function onSelectFile(e) {

        if (e.target.files[0].type !== 'text/csv') {
            setError('Arquivo inválido! Selecione um arquivo CSV válido.')
            setSelectedCSV(e.target.files[0])
            setAllowedImport(false)
            return
        }

        setError('')
        setSelectedCSV(e.target.files[0])
        setAllowedImport(true)
    }
    function click() {
        const inputFile = document.getElementById("import-csv-askdjhasd")

        inputFile.value = ''
        inputFile.click()
    }

    function openModal() {
        setSelectedCSV({})
        if (importedProducts.length) {
            setModalProducts(true)
        } else {
            setShowModal(true)
        }
    }

    function importData() {

        importNFEData(selectedCSV, 'csv')
            .then(response => {
                setImportedProducts(response.products)
                console.log("response.productsresponse.products",response.products)
                setShowModal(false)
                setModalProducts(true)
                setError('')
                setDisabled(true)
            })
            .catch(err => {
                console.log(err)
                setError('Erro no CSV! Selecione um CSV Válido.')
            })
    }

    function setIcmsItens(icms) {


        let temp = importedProducts

        for (let i = 0; i < temp.length; i++) {
            temp[i].icms = icms
            if (temp[i].icms.name == 'Selecione o icms') {
                setDisabled(true)
            }
            else {
                setDisabled(false)
            }
        }
        setImportedProducts(temp)
    }

    const data = [
        ['Codigo', 'Descricao', 'NCM', 'CFOP', 'Unidade', 'ValorDeVenda', 'CodigoDeBarras']
    ]

    const downloadCSV = () => {
        const csvContent = "data:text/csv;charset=utf-8," + data.map(row => row.join(";")).join("\n");
        const encodedURI = encodeURI(csvContent);
        const link = document.createElement('a');
        link.setAttribute('href', encodedURI);
        link.setAttribute('download', 'template.csv');
        document.body.appendChild(link);
        link.click();
    }


    function createProduct() {

        let product_list = []
        const payload = product => {
            showSnackBar("Produtos cadastrados com sucesso", "primary")
            setTimeout(() => {
                window.location.href = `/products`
            }, 500)
        }

        const errorPayload = err => {
            let data = JSON.parse(err.response)
            for (let i = 0; i < data.length; i++) {
                const element = data[i]
                if (element.code[0]) {
                    showSnackBar('O campo Codigo precisa ser único.')
                }
            }

        }

        for (let i = 0; i < importedProducts.length; i++) {

            let temp = {

                "ref_code": importedProducts[i].Codigo,
                "name": importedProducts[i].Descricao,
                "barcode": importedProducts[i].CodigoDeBarras,
                "unit": importedProducts[i].Unidade.id,
                "price": importedProducts[i].ValorDeVenda,
                "fiscal": {
                    "ncm": importedProducts[i].NCM.id? importedProducts[i].NCM.id : importedProducts[i].NCM,
                    "cfop": importedProducts[i].CFOP.id,
                    "template_icms": importedProducts[i].icms.id
                }
            }

                product_list.push(temp)


        }
        saveProduct(product_list, payload, errorPayload, true)
    }

    return <div>
        <input
            accept="text/csv"
            onChange={onSelectFile}
            id="import-csv-askdjhasd"
            type="file"
            className="d-none" />
        <Button onClick={openModal}>
            Importar via CSV
        </Button>
        <Modal title="Importar produto via CSV" show={showModal} onHide={() => setShowModal(false)}>



            {selectedCSV.name && selectedCSV.size <= 160000 ? <div>
                {error.length ? <h4 className="text-danger text-center" >{error}</h4> : ''}
                <h3 className="text-center">{selectedCSV.name}</h3>
            </div> :

                <div className="d-flex justify-content-center w-100 flex-column">
                    <ContainerDragAndDrop onClick={click}>
                        <i className="fas fa-file-upload text-info"></i>
                    </ContainerDragAndDrop>
                    <h3 className="text-info text-center" >Selecione um CSV</h3>
                </div>
            }
            {selectedCSV.size >= 160000 ? <h1 className="font-bold text-center">Arquivo muito pesado! (Max. de 15kb)
                <br />
                Fale com o <a target="_blank" href="https://wa.me/5511966466526">Suporte</a> para mais informações.</h1>
                :
                <div className="d-flex flex-row-reverse">
                    <Button disabled={!allowedImport} onClick={importData}>Importar</Button>
                </div>
            }

            {selectedCSV.name ? <div /> : <div>

                <p className="font-weight-bold ml-0" style={{ fontSize: 17 }}> Baixe o layout do CSV <a onClick={() => { downloadCSV() }} href="#">clicando aqui</a>.</p>

            </div>}


        </Modal>

        <Modal
            style={{ zIndex: 999 }}
            title="Produtos Encontrados"
            show={modalProducts}
            onHide={() => {
                setImportedProducts([])
                setModalProducts(false)
                setShowModal(true)
            }}
        >
            <table class="table table-responsive-sm table-hover">
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Nome</th>
                        <th scope="col">Preço</th>
                        <th scope="col">NCM</th>
                        <th scope="col">CFOP</th>
                    </tr>
                </thead>
                <tbody>
                    {importedProducts.map((prod, _) => <tr key={`imported_${_}`}>
                        <th scope="row">{_ + 1}</th>
                        <td>{prod.Descricao ? prod.Descricao : 'N/A'}</td>
                        <td>R$ {prod.ValorDeVenda ? prod.ValorDeVenda : 'N/A'}</td>
                        <td>{prod.NCM.code ? prod.NCM.code : "0"+prod.NCM}</td>
                        <td>{prod.CFOP.code ? prod.CFOP.code : 'N/A'}</td>
                    </tr>)}
                </tbody>
            </table>

            <Row className="justify-content-between col-12">

                <SelectICMS onChangeIcms={setIcmsItens} />

                <Button onClick={() => { createProduct() }} disabled={disabled} style={{ flexDirection: 'column', alignSelf: 'flex-end' }}>Cadastrar {importedProducts.length > 1 ? 'itens' : 'item'}</Button>

            </Row>


        </Modal>
    </div>
}

const mapStateToProps = state => ({})
const mapDispatchToProps = disptch => bindActionCreators({
    setBaseProductName,
    setNcm,
    setCfop,
    setBaseProductBarcode,
    setBaseProductPrice,
    // setBaseProductInternalCode,
    setMaskPrice,
    setNcm, setCfop
}, disptch);

export default connect(mapStateToProps, mapDispatchToProps)(ImportCSV)


// WEBPACK FOOTER //
// ./src/views/AppViews/Products/imports/ProductCSV/index.jsx